"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SanctuaryAbilityHandler = exports.SanctuaryActorAbilityFactory = exports.SanctuaryAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const Registries_1 = require("../../core/state/Registries");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class SanctuaryAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.Sanctuary;
        this.__typeName = "Sanctuary";
    }
}
exports.SanctuaryAbilityArgs = SanctuaryAbilityArgs;
let SanctuaryActorAbilityFactory = class SanctuaryActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("Sanctuary", "OneAllies", 2);
    }
};
SanctuaryActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("Sanctuary")
], SanctuaryActorAbilityFactory);
exports.SanctuaryActorAbilityFactory = SanctuaryActorAbilityFactory;
let SanctuaryAbilityHandler = class SanctuaryAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedAllyOrSelf] = ability.args.target.actorIds;
        sequence.push(new core_2.AnimateCharacterAbilityVfxStepArgs(ability.invokerId, "Sanctuary", "casting"));
        sequence = sequence.pushSequence("parallel");
        container.applyHealing({
            healerId: ability.invokerId,
            targetId: selectedAllyOrSelf,
            amount: container.getPercentOfBaseHealth(selectedAllyOrSelf, 10),
            sequence: sequence
        });
        container.applyBuff({
            sequence: sequence,
            creatorId: ability.invokerId,
            targetId: selectedAllyOrSelf,
            duration: Duration_1.Duration.Permanent,
            effect: new core_1.DamageAbsorbEffectArgs({
                [enums_1.DamageType.All]: container.getPercentOfBaseHealth(selectedAllyOrSelf, 10),
            }),
            onApplied: (sequence) => {
                sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedAllyOrSelf, "feet", "behind"), "DarkMagicCircle"));
            }
        });
    }
};
SanctuaryAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.Sanctuary)
], SanctuaryAbilityHandler);
exports.SanctuaryAbilityHandler = SanctuaryAbilityHandler;
